export interface PlanInfoProps {
  [key: string]: {
    name: string;
    price: number;
    periodPrice: number;
    description: string;
    disclaimer?: string;
    product_id: string;
    duration: string;
    currency?: string; // 'USD' | 'EUR' | 'MXN',
    currencySymbol?: string; // '$' | '€' | 'Mex$',
  };
}

export const PLANS: PlanInfoProps = {
  'fm-3429-gbp-1-month-intro-256-gbp-3-day-sub': {
    name: 'fm-3429-gbp-1-month-intro-256-gbp-3-day-sub',
    price: 34.29,
    periodPrice: 2.56,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - £34.29',
    duration: '3 days - 1 month',
    currency: 'GBP',
    currencySymbol: '£',
  },
  'fm-3429-gbp-1-month-intro-514-gbp-3-day-sub': {
    name: 'fm-3429-gbp-1-month-intro-514-gbp-3-day-sub',
    price: 34.29,
    periodPrice: 5.14,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - £34.29',
    duration: '3 days - 1 month',
    currency: 'GBP',
    currencySymbol: '£',
  },
  'fm-3429-gbp-1-month-intro-1714-gbp-1-month-sub': {
    name: 'fm-3429-gbp-1-month-intro-1714-gbp-1-month-sub',
    price: 34.29,
    periodPrice: 34.29,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - £34.29',
    duration: '1 month',
    currency: 'GBP',
    currencySymbol: '£',
  },
  'fm-5143-gbp-3-month-intro-3429-gbp-3-month-sub': {
    name: 'fm-5143-gbp-3-month-intro-3429-gbp-3-month-sub',
    price: 51.43,
    periodPrice: 51.43,
    description: 'quarterly',
    disclaimer: 'quarterly',
    product_id: '3 months - £51.43',
    duration: '3 months',
    currency: 'GBP',
    currencySymbol: '£',
  },
  'fm-monthly-intro1d-99-4999': {
    name: 'fm-monthly-intro1d-99-4999',
    price: 49.99,
    periodPrice: 0.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - $49.99',
    duration: '1 day - 1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-monthly-intro1d-125-4999': {
    name: 'fm-monthly-intro1d-125-4999',
    price: 49.99,
    periodPrice: 1.25,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - $49.99',
    duration: '1 day - 1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-monthly-intro1d-250-4999': {
    name: 'fm-monthly-intro1d-250-4999',
    price: 49.99,
    periodPrice: 2.5,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - $49.99',
    duration: '1 day - 1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-monthly-4999': {
    name: 'fm-monthly-4999',
    price: 49.99,
    periodPrice: 49.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - $49.99',
    duration: '1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-monthly-intro7d-6.99-39.99': {
    name: 'fm-monthly-intro7d-6.99-39.99',
    price: 39.99,
    periodPrice: 6.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - $39.99',
    duration: 'week - month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-monthly-intro7d-111-211': {
    name: 'fm-monthly-intro7d-111-211',
    price: 2.11,
    periodPrice: 1.11,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - $2.11',
    duration: 'week - month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-monthly-39.99': {
    name: 'fm-monthly-39.99',
    price: 39.99,
    periodPrice: 39.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - $39.99',
    duration: '1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-monthly-212': {
    name: 'fm-monthly-212',
    price: 2.12,
    periodPrice: 2.12,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - $2.12',
    duration: '1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-3month-59.99': {
    name: 'fm-3month-59.99',
    price: 59.99,
    periodPrice: 59.99,
    description: 'quarterly',
    disclaimer: 'quarterly',
    product_id: '3 months - $59.99',
    duration: '3 months',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-9999-usd-6-month-sub': {
    name: 'fm-9999-usd-6-month-sub',
    price: 99.99,
    periodPrice: 99.99,
    description: 'semi-annually',
    product_id: '6 months - $99.99',
    duration: '6 months',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-3month-313': {
    name: 'fm-3month-313',
    price: 3.13,
    periodPrice: 3.13,
    description: 'quarterly',
    disclaimer: 'quarterly',
    product_id: '3 months - $3.13',
    duration: '3 months',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-3999-usd-1-month-intro-499-usd-5-day-sub': {
    name: 'fm-3999-usd-1-month-intro-499-usd-5-day-sub',
    price: 39.99,
    periodPrice: 4.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - $39.99',
    duration: '5 days - 1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-3999-usd-1-month-intro-999-usd-5-day-sub': {
    name: 'fm-3999-usd-1-month-intro-999-usd-5-day-sub',
    price: 39.99,
    periodPrice: 9.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - $39.99',
    duration: '5 days - 1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-3999-usd-1-month-intro-299-usd-3-day-sub': {
    name: 'fm-3999-usd-1-month-intro-299-usd-3-day-sub',
    price: 39.99,
    periodPrice: 2.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - $39.99',
    duration: '3 days - 1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-3999-usd-1-month-intro-149-usd-3-day-sub': {
    name: 'fm-3999-usd-1-month-intro-149-usd-3-day-sub',
    price: 39.99,
    periodPrice: 1.49,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - $39.99',
    duration: '3 days - 1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-3999-usd-1-month-intro-239-usd-3-day-sub': {
    name: 'fm-3999-usd-1-month-intro-239-usd-3-day-sub',
    price: 39.99,
    periodPrice: 2.39,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - $39.99',
    duration: '3 days - 1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-3999-usd-1-month-intro-999-usd-1-month-sub': {
    name: 'fm-3999-usd-1-month-intro-999-usd-1-month-sub',
    price: 39.99,
    periodPrice: 39.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - $39.99',
    duration: '1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-3999-usd-1-month-intro-1599-usd-1-month-sub': {
    name: 'fm-3999-usd-1-month-intro-1599-usd-1-month-sub',
    price: 39.99,
    periodPrice: 39.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - $39.99',
    duration: '1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-5999-usd-3-month-intro-1499-usd-3-month-sub': {
    name: 'fm-5999-usd-3-month-intro-1499-usd-3-month-sub',
    price: 59.99,
    periodPrice: 59.99,
    description: 'quarterly',
    disclaimer: 'quarterly',
    product_id: '3 months - $59.99',
    duration: '3 months',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-5999-usd-3-month-intro-2399-usd-3-month-sub': {
    name: 'fm-5999-usd-3-month-intro-2399-usd-3-month-sub',
    price: 59.99,
    periodPrice: 59.99,
    description: 'quarterly',
    disclaimer: 'quarterly',
    product_id: '3 months - $59.99',
    duration: '3 months',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-3999-usd-1-month-intro-599-usd-3-day-sub': {
    name: 'fm-3999-usd-1-month-intro-599-usd-3-day-sub',
    price: 39.99,
    periodPrice: 5.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - $39.99',
    duration: '3 days - 1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-3999-usd-1-month-intro-699-usd-3-day-sub': {
    name: 'fm-3999-usd-1-month-intro-699-usd-3-day-sub',
    price: 39.99,
    periodPrice: 6.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - $39.99',
    duration: '3 days - 1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-3999-usd-1-month-intro-599-usd-7-day-sub': {
    name: 'fm-3999-usd-1-month-intro-599-usd-7-day-sub',
    price: 39.99,
    periodPrice: 5.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - $39.99',
    duration: 'week - month',
    currency: 'USD',
    currencySymbol: '$',
  },
  // euro plans
  'fm-monthly-intro1d-99-4999-eur': {
    name: 'fm-monthly-intro1d-99-4999-eur',
    price: 49.99,
    periodPrice: 0.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - €49.99',
    duration: '1 day - 1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fm-monthly-intro1d-125-4999-eur': {
    name: 'fm-monthly-intro1d-125-4999-eur',
    price: 49.99,
    periodPrice: 1.25,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - €49.99',
    duration: '1 day - 1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fm-monthly-intro1d-250-4999-eur': {
    name: 'fm-monthly-intro1d-250-4999-eur',
    price: 49.99,
    periodPrice: 2.5,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - €49.99',
    duration: '1 day - 1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fm-monthly-4999-eur': {
    name: 'fm-monthly-4999-eur',
    price: 49.99,
    periodPrice: 49.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - €49.99',
    duration: '1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fm-monthly-intro7d-6.99-39.99-eur': {
    name: 'fm-monthly-intro7d-6.99-39.99-eur',
    price: 39.99,
    periodPrice: 6.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - €39.99',
    duration: 'week - month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fm-monthly-intro7d-111-211-eur': {
    name: 'fm-monthly-intro7d-111-211-eur',
    price: 2.11,
    periodPrice: 1.11,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - €2.11',
    duration: 'week - month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fm-monthly-39.99-eur': {
    name: 'fm-monthly-39.99-eur',
    price: 39.99,
    periodPrice: 39.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - €39.99',
    duration: '1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fm-monthly-212-eur': {
    name: 'fm-monthly-212-eur',
    price: 2.12,
    periodPrice: 2.12,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - €2.12',
    duration: '1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fm-3month-59.99-eur': {
    name: 'fm-3month-59.99-eur',
    price: 59.99,
    periodPrice: 59.99,
    description: 'quarterly',
    disclaimer: 'quarterly',
    product_id: '3 months - €59.99',
    duration: '3 months',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fm-3month-313-eur': {
    name: 'fm-3month-313-eur',
    price: 3.13,
    periodPrice: 3.13,
    description: 'quarterly',
    disclaimer: 'quarterly',
    product_id: '3 months - €3.13',
    duration: '3 months',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fm-3999-eur-1-month-intro-499-eur-5-day-sub': {
    name: 'fm-3999-eur-1-month-intro-499-eur-5-day-sub',
    price: 39.99,
    periodPrice: 4.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - €39.99',
    duration: '5 days - 1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fm-3999-eur-1-month-intro-999-eur-5-day-sub': {
    name: 'fm-3999-eur-1-month-intro-999-eur-5-day-sub',
    price: 39.99,
    periodPrice: 9.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - €39.99',
    duration: '5 days - 1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fm-3999-eur-1-month-intro-299-eur-3-day-sub': {
    name: 'fm-3999-eur-1-month-intro-299-eur-3-day-sub',
    price: 39.99,
    periodPrice: 2.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - €39.99',
    duration: '3 days - 1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fm-3999-eur-1-month-intro-149-eur-3-day-sub': {
    name: 'fm-3999-eur-1-month-intro-149-eur-3-day-sub',
    price: 39.99,
    periodPrice: 1.49,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - €39.99',
    duration: '3 days - 1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fm-3999-eur-1-month-intro-239-eur-3-day-sub': {
    name: 'fm-3999-eur-1-month-intro-239-eur-3-day-sub',
    price: 39.99,
    periodPrice: 2.39,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - €39.99',
    duration: '3 days - 1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fm-3999-eur-1-month-intro-999-eur-1-month-sub': {
    name: 'fm-3999-eur-1-month-intro-999-eur-1-month-sub',
    price: 39.99,
    periodPrice: 39.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - €39.99',
    duration: '1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fm-3999-eur-1-month-intro-1599-eur-1-month-sub': {
    name: 'fm-3999-eur-1-month-intro-1599-eur-1-month-sub',
    price: 39.99,
    periodPrice: 39.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - €39.99',
    duration: '1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fm-5999-eur-3-month-intro-1499-eur-3-month-sub': {
    name: 'fm-5999-eur-3-month-intro-1499-eur-3-month-sub',
    price: 59.99,
    periodPrice: 59.99,
    description: 'quarterly',
    disclaimer: 'quarterly',
    product_id: '3 months - €59.99',
    duration: '3 months',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fm-5999-eur-3-month-intro-2399-eur-3-month-sub': {
    name: 'fm-5999-eur-3-month-intro-2399-eur-3-month-sub',
    price: 59.99,
    periodPrice: 59.99,
    description: 'quarterly',
    disclaimer: 'quarterly',
    product_id: '3 months - €59.99',
    duration: '3 months',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fm-3999-eur-1-month-intro-599-eur-3-day-sub': {
    name: 'fm-3999-eur-1-month-intro-599-eur-3-day-sub',
    price: 39.99,
    periodPrice: 5.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - €39.99',
    duration: '3 days - 1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fm-3999-eur-1-month-intro-699-eur-3-day-sub': {
    name: 'fm-3999-eur-1-month-intro-699-eur-3-day-sub',
    price: 39.99,
    periodPrice: 6.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - €39.99',
    duration: '3 days - 1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fm-3999-eur-1-month-intro-599-eur-7-day-sub': {
    name: 'fm-3999-eur-1-month-intro-599-eur-7-day-sub',
    price: 39.99,
    periodPrice: 5.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - €39.99',
    duration: 'week - month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  // upsell plans
  'fm-monthly-upsell-999': {
    name: 'fm-monthly-upsell-999',
    price: 9.99,
    periodPrice: 9.99,
    description: 'monthly upsell',
    disclaimer: 'monthly',
    product_id: '1 month - upsell $9.99',
    duration: '1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-monthly-upsell-1399': {
    name: 'fm-monthly-upsell-1399',
    price: 13.99,
    periodPrice: 13.99,
    description: 'monthly upsell',
    disclaimer: 'monthly',
    product_id: '1 month - upsell $13.99',
    duration: '1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-monthly-upsell-111': {
    name: 'fm-monthly-upsell-111',
    price: 1.11,
    periodPrice: 1.11,
    description: 'monthly upsell',
    disclaimer: 'monthly',
    product_id: '1 month - upsell $1.11',
    duration: '1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-monthly-upsell-112': {
    name: 'fm-monthly-upsell-112',
    price: 1.12,
    periodPrice: 1.12,
    description: 'monthly upsell',
    disclaimer: 'monthly',
    product_id: '1 month - upsell $1.12',
    duration: '1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-monthly-upsell-113': {
    name: 'fm-monthly-upsell-113',
    price: 1.13,
    periodPrice: 1.13,
    description: 'monthly upsell',
    disclaimer: 'monthly',
    product_id: '1 month - upsell $1.13',
    duration: '1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-monthly-upsell-799': {
    name: 'fm-monthly-upsell-799',
    price: 7.99,
    periodPrice: 7.99,
    description: 'monthly upsell',
    disclaimer: 'monthly',
    product_id: '1 month - upsell $7.99',
    duration: '1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-monthly-upsell-599': {
    name: 'fm-monthly-upsell-599',
    price: 5.99,
    periodPrice: 5.99,
    description: 'monthly upsell',
    disclaimer: 'monthly',
    product_id: '1 month - upsell $5.99',
    duration: '1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-3month-upsell-999': {
    name: 'fm-3month-upsell-999',
    price: 9.99,
    periodPrice: 9.99,
    description: 'quarterly upsell',
    disclaimer: 'quarterly',
    product_id: '3 months - upsell $9.99',
    duration: '3 months',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-3month-upsell-1399': {
    name: 'fm-3month-upsell-1399',
    price: 13.99,
    periodPrice: 13.99,
    description: 'quarterly upsell',
    disclaimer: 'quarterly',
    product_id: '3 months - upsell $13.99',
    duration: '3 months',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-3month-upsell-111': {
    name: 'fm-3month-upsell-111',
    price: 1.11,
    periodPrice: 1.11,
    description: 'quarterly upsell',
    disclaimer: 'quarterly',
    product_id: '3 months - upsell $1.11',
    duration: '3 months',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-3month-upsell-112': {
    name: 'fm-3month-upsell-112',
    price: 1.12,
    periodPrice: 1.12,
    description: 'quarterly upsell',
    disclaimer: 'quarterly',
    product_id: '3 months - upsell $1.12',
    duration: '3 months',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-3month-upsell-113': {
    name: 'fm-3month-upsell-113',
    price: 1.13,
    periodPrice: 1.13,
    description: 'quarterly upsell',
    disclaimer: 'quarterly',
    product_id: '3 months - upsell $1.13',
    duration: '3 months',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-3month-upsell-799': {
    name: 'fm-3month-upsell-799',
    price: 7.99,
    periodPrice: 7.99,
    description: 'quarterly upsell',
    disclaimer: 'quarterly',
    product_id: '3 months - upsell $7.99',
    duration: '3 months',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-3month-upsell-599': {
    name: 'fm-3month-upsell-599',
    price: 5.99,
    periodPrice: 5.99,
    description: 'quarterly upsell',
    disclaimer: 'quarterly',
    product_id: '3 months - upsell $5.99',
    duration: '3 months',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-monthly-upsell-999-eur': {
    name: 'fm-monthly-upsell-999-eur',
    price: 9.99,
    periodPrice: 9.99,
    description: 'monthly upsell',
    disclaimer: 'monthly',
    product_id: '1 month - upsell €9.99',
    duration: '1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fm-monthly-upsell-1399-eur': {
    name: 'fm-monthly-upsell-1399-eur',
    price: 13.99,
    periodPrice: 13.99,
    description: 'monthly upsell',
    disclaimer: 'monthly',
    product_id: '1 month - upsell €13.99',
    duration: '1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fm-monthly-upsell-111-eur': {
    name: 'fm-monthly-upsell-111-eur',
    price: 1.11,
    periodPrice: 1.11,
    description: 'monthly upsell',
    disclaimer: 'monthly',
    product_id: '1 month - upsell €1.11',
    duration: '1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fm-monthly-upsell-112-eur': {
    name: 'fm-monthly-upsell-112-eur',
    price: 1.12,
    periodPrice: 1.12,
    description: 'monthly upsell',
    disclaimer: 'monthly',
    product_id: '1 month - upsell €1.12',
    duration: '1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fm-monthly-upsell-113-eur': {
    name: 'fm-monthly-upsell-113-eur',
    price: 1.13,
    periodPrice: 1.13,
    description: 'monthly upsell',
    disclaimer: 'monthly',
    product_id: '1 month - upsell €1.13',
    duration: '1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fm-monthly-upsell-799-eur': {
    name: 'fm-monthly-upsell-799-eur',
    price: 7.99,
    periodPrice: 7.99,
    description: 'monthly upsell',
    disclaimer: 'monthly',
    product_id: '1 month - upsell €7.99',
    duration: '1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fm-monthly-upsell-599-eur': {
    name: 'fm-monthly-upsell-599-eur',
    price: 5.99,
    periodPrice: 5.99,
    description: 'monthly upsell',
    disclaimer: 'monthly',
    product_id: '1 month - upsell €5.99',
    duration: '1 month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fm-3month-upsell-999-eur': {
    name: 'fm-3month-upsell-999-eur',
    price: 9.99,
    periodPrice: 9.99,
    description: 'quarterly upsell',
    disclaimer: 'quarterly',
    product_id: '3 months - upsell €9.99',
    duration: '3 months',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fm-3month-upsell-1399-eur': {
    name: 'fm-3month-upsell-1399-eur',
    price: 13.99,
    periodPrice: 13.99,
    description: 'quarterly upsell',
    disclaimer: 'quarterly',
    product_id: '3 months - upsell €13.99',
    duration: '3 months',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fm-3month-upsell-111-eur': {
    name: 'fm-3month-upsell-111-eur',
    price: 1.11,
    periodPrice: 1.11,
    description: 'quarterly upsell',
    disclaimer: 'quarterly',
    product_id: '3 months - upsell €1.11',
    duration: '3 months',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fm-3month-upsell-112-eur': {
    name: 'fm-3month-upsell-112-eur',
    price: 1.12,
    periodPrice: 1.12,
    description: 'quarterly upsell',
    disclaimer: 'quarterly',
    product_id: '3 months - upsell €1.12',
    duration: '3 months',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fm-3month-upsell-113-eur': {
    name: 'fm-3month-upsell-113-eur',
    price: 1.13,
    periodPrice: 1.13,
    description: 'quarterly upsell',
    disclaimer: 'quarterly',
    product_id: '3 months - upsell €1.13',
    duration: '3 months',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fm-3month-upsell-799-eur': {
    name: 'fm-3month-upsell-799-eur',
    price: 7.99,
    periodPrice: 7.99,
    description: 'quarterly upsell',
    disclaimer: 'quarterly',
    product_id: '3 months - upsell €7.99',
    duration: '3 months',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fm-3month-upsell-599-eur': {
    name: 'fm-3month-upsell-599-eur',
    price: 5.99,
    periodPrice: 5.99,
    description: 'quarterly upsell',
    disclaimer: 'quarterly',
    product_id: '3 months - upsell €5.99',
    duration: '3 months',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fm-onetime-upsell-guide-899': {
    name: 'fm-onetime-upsell-guide-899',
    price: 8.99,
    periodPrice: 8.99,
    description: 'one-time',
    product_id: 'one-time payment - $8.99',
    duration: 'one-time',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-onetime-upsell-test-114': {
    name: 'fm-onetime-upsell-test-114',
    price: 1.14,
    periodPrice: 1.14,
    description: 'one-time',
    product_id: 'one-time payment - $1.14',
    duration: 'one-time',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-onetime-upsell-guide-1799': {
    name: 'fm-onetime-upsell-guide-1799',
    price: 17.99,
    periodPrice: 17.99,
    description: 'one-time',
    product_id: 'one-time payment - $17.99',
    duration: 'one-time',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-onetime-upsell-guide-899-eur': {
    name: 'fm-onetime-upsell-guide-899-eur',
    price: 8.99,
    periodPrice: 8.99,
    description: 'one-time',
    product_id: 'one-time payment - €8.99',
    duration: 'one-time',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fm-onetime-upsell-test-114-eur': {
    name: 'fm-onetime-upsell-test-114-eur',
    price: 1.14,
    periodPrice: 1.14,
    description: 'one-time',
    product_id: 'one-time payment - €1.14',
    duration: 'one-time',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fm-onetime-upsell-guide-1799-eur': {
    name: 'fm-onetime-upsell-guide-1799-eur',
    price: 17.99,
    periodPrice: 17.99,
    description: 'one-time',
    product_id: 'one-time payment - €17.99',
    duration: 'one-time',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fm-3699-usd-1-month-intro-299-usd-3-day-sub': {
    name: 'fm-3699-usd-1-month-intro-299-usd-3-day-sub',
    price: 36.99,
    periodPrice: 2.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - $36.99',
    duration: '3 days - month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-4999-usd-1-month-intro-799-usd-3-day-sub': {
    name: 'fm-4999-usd-1-month-intro-799-usd-3-day-sub',
    price: 49.99,
    periodPrice: 7.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - $49.99',
    duration: '3 days - month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-3699-eur-1-month-intro-299-eur-3-day-sub': {
    name: 'fm-3699-eur-1-month-intro-299-eur-3-day-sub',
    price: 36.99,
    periodPrice: 2.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - €36.99',
    duration: '3 days - month',
    currency: 'EUR',
    currencySymbol: '€',
  },
  'fm-4999-eur-1-month-intro-799-eur-3-day-sub': {
    name: 'fm-4999-eur-1-month-intro-799-eur-3-day-sub',
    price: 49.99,
    periodPrice: 7.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - €49.99',
    duration: '3 days - month',
    currency: 'EUR',
    currencySymbol: '€',
  },

  'fm-19999-brl-1-month-intro-1499-brl-3-day-sub': {
    name: 'fm-19999-brl-1-month-intro-1499-brl-3-day-sub',
    price: 199.99,
    periodPrice: 14.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - R$199.99',
    duration: '3 days - month',
    currency: 'BRL',
    currencySymbol: 'R$',
  },
  'fm-19999-brl-1-month-intro-2899-brl-3-day-sub': {
    name: 'fm-19999-brl-1-month-intro-2899-brl-3-day-sub',
    price: 199.99,
    periodPrice: 28.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - R$199.99',
    duration: '3 days - month',
    currency: 'BRL',
    currencySymbol: 'R$',
  },
  'fm-19999-brl-1-month-intro-9799-brl-1-month-sub': {
    name: 'fm-19999-brl-1-month-intro-9799-brl-1-month-sub',
    price: 199.99,
    periodPrice: 199.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - R$199.99',
    duration: '1 month',
    currency: 'BRL',
    currencySymbol: 'R$',
  },
  'fm-28999-brl-3-month-intro-19999-brl-3-month-sub': {
    name: 'fm-28999-brl-3-month-intro-19999-brl-3-month-sub',
    price: 289.99,
    periodPrice: 289.99,
    description: 'quarterly',
    disclaimer: 'quarterly',
    product_id: '3 months - R$289.99',
    duration: '3 months',
    currency: 'BRL',
    currencySymbol: 'R$',
  },
  'fm-372332-inr-1-month-intro-27839-inr-3-day-sub': {
    name: 'fm-372332-inr-1-month-intro-27839-inr-3-day-sub',
    price: 3723.32,
    periodPrice: 278.39,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - ₹3723.32',
    duration: '3 days - month',
    currency: 'INR',
    currencySymbol: '₹',
  },
  'fm-372332-inr-1-month-intro-55771-inr-3-day-sub': {
    name: 'fm-372332-inr-1-month-intro-55771-inr-3-day-sub',
    price: 3723.32,
    periodPrice: 557.71,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - ₹3723.32',
    duration: '3 days - month',
    currency: 'INR',
    currencySymbol: '₹',
  },
  'fm-372332-inr-1-month-intro-186119-inr-1-month-sub': {
    name: 'fm-372332-inr-1-month-intro-186119-inr-1-month-sub',
    price: 3723.32,
    periodPrice: 3723.32,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - ₹3723.32',
    duration: '1 month',
    currency: 'INR',
    currencySymbol: '₹',
  },
  'fm-558544-inr-3-month-intro-372332-inr-3-month-sub': {
    name: 'fm-558544-inr-3-month-intro-372332-inr-3-month-sub',
    price: 5585.44,
    periodPrice: 5585.44,
    description: 'quarterly',
    disclaimer: 'quarterly',
    product_id: '3 months - ₹5585.44',
    duration: '3 months',
    currency: 'INR',
    currencySymbol: '₹',
  },
  'fm-14728-pln-1-month-intro-1101-pln-3-day-sub': {
    name: 'fm-14728-pln-1-month-intro-1101-pln-3-day-sub',
    price: 147.28,
    periodPrice: 11.01,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - zł147.28',
    duration: '3 days - month',
    currency: 'PLN',
    currencySymbol: 'zł',
  },
  'fm-14728-pln-1-month-intro-2206-pln-3-day-sub': {
    name: 'fm-14728-pln-1-month-intro-2206-pln-3-day-sub',
    price: 147.28,
    periodPrice: 22.06,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - zł147.28',
    duration: '3 days - month',
    currency: 'PLN',
    currencySymbol: 'zł',
  },
  'fm-14728-pln-1-month-intro-7362-pln-1-month-sub': {
    name: 'fm-14728-pln-1-month-intro-7362-pln-1-month-sub',
    price: 147.28,
    periodPrice: 147.28,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - zł147.28',
    duration: '1 month',
    currency: 'PLN',
    currencySymbol: 'zł',
  },
  'fm-22094-pln-3-month-intro-14728-pln-3-month-sub': {
    name: 'fm-22094-pln-3-month-intro-14728-pln-3-month-sub',
    price: 220.94,
    periodPrice: 220.94,
    description: 'quarterly',
    disclaimer: 'quarterly',
    product_id: '3 months - zł220.94',
    duration: '3 months',
    currency: 'PLN',
    currencySymbol: 'zł',
  },

  // pan territory pricing
  'fm-2999-usd-1-month-intro-199-usd-3-day-sub': {
    name: 'fm-2999-usd-1-month-intro-199-usd-3-day-sub',
    price: 29.99,
    periodPrice: 1.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - $29.99',
    duration: '3 days - month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-2999-usd-1-month-intro-399-usd-3-day-sub': {
    name: 'fm-2999-usd-1-month-intro-399-usd-3-day-sub',
    price: 29.99,
    periodPrice: 3.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - $29.99',
    duration: '3 days - month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-2999-usd-1-month-intro-1499-usd-1-month-sub': {
    name: 'fm-2999-usd-1-month-intro-1499-usd-1-month-sub',
    price: 29.99,
    periodPrice: 29.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - $29.99',
    duration: '1 month',
    currency: 'USD',
    currencySymbol: '$',
  },
  'fm-4499-usd-3-month-intro-2999-usd-3-month-sub': {
    name: 'fm-4499-usd-3-month-intro-2999-usd-3-month-sub',
    price: 44.99,
    periodPrice: 44.99,
    description: 'quarterly',
    disclaimer: 'quarterly',
    product_id: '3 months - $44.99',
    duration: '3 months',
    currency: 'USD',
    currencySymbol: '$',
  },
  // cop territory pricing
  'fm-13990000-cop-1-month-intro-990000-cop-3-day-sub': {
    name: 'fm-13990000-cop-1-month-intro-990000-cop-3-day-sub',
    price: 139900,
    periodPrice: 9900,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - COP139900',
    duration: '3 days - month',
    currency: 'COP',
    currencySymbol: 'COP',
  },
  'fm-13990000-cop-1-month-intro-1980000-cop-3-day-sub': {
    name: 'fm-13990000-cop-1-month-intro-1980000-cop-3-day-sub',
    price: 139900,
    periodPrice: 19800,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - COP139900',
    duration: '3 days - month',
    currency: 'COP',
    currencySymbol: 'COP',
  },
  'fm-13990000-cop-1-month-intro-6990000-cop-1-month-sub': {
    name: 'fm-13990000-cop-1-month-intro-6990000-cop-1-month-sub',
    price: 139900,
    periodPrice: 139900,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - COP139900',
    duration: '1 month',
    currency: 'COP',
    currencySymbol: 'COP',
  },
  'fm-20990000-cop-3-month-intro-13990000-cop-3-month-sub': {
    name: 'fm-20990000-cop-3-month-intro-13990000-cop-3-month-sub',
    price: 209900,
    periodPrice: 209900,
    description: 'quarterly',
    disclaimer: 'quarterly',
    product_id: '3 months - COP209900',
    duration: '3 months',
    currency: 'COP',
    currencySymbol: 'COP',
  },
  'fm-2400000-cop-1-month-upsell': {
    name: 'fm-2400000-cop-1-month-upsell',
    price: 24000,
    periodPrice: 24000,
    description: 'monthly upsell',
    disclaimer: 'monthly',
    product_id: '1 month - upsell COP24000',
    duration: '1 month',
    currency: 'COP',
    currencySymbol: 'COP',
  },
  'fm-3400000-cop-1-month-upsell': {
    name: 'fm-3400000-cop-1-month-upsell',
    price: 34000,
    periodPrice: 34000,
    description: 'monthly upsell',
    disclaimer: 'monthly',
    product_id: '1 month - upsell COP34000',
    duration: '1 month',
    currency: 'COP',
    currencySymbol: 'COP',
  },
  'fm-1900000-cop-1-month-upsell': {
    name: 'fm-1900000-cop-1-month-upsell',
    price: 19000,
    periodPrice: 19000,
    description: 'monthly upsell',
    disclaimer: 'monthly',
    product_id: '1 month - upsell COP19000',
    duration: '1 month',
    currency: 'COP',
    currencySymbol: 'COP',
  },
  'fm-1400000-cop-1-month-upsell': {
    name: 'fm-1400000-cop-1-month-upsell',
    price: 14000,
    periodPrice: 14000,
    description: 'monthly upsell',
    disclaimer: 'monthly',
    product_id: '1 month - upsell COP14000',
    duration: '1 month',
    currency: 'COP',
    currencySymbol: 'COP',
  },
  'fm-2400000-cop-3-month-upsell': {
    name: 'fm-2400000-cop-3-month-upsell',
    price: 24000,
    periodPrice: 24000,
    description: 'quarterly upsell',
    disclaimer: 'quarterly',
    product_id: '3 months - upsell COP24000',
    duration: '3 months',
    currency: 'COP',
    currencySymbol: 'COP',
  },
  'fm-3400000-cop-3-month-upsell': {
    name: 'fm-3400000-cop-3-month-upsell',
    price: 34000,
    periodPrice: 34000,
    description: 'quarterly upsell',
    disclaimer: 'quarterly',
    product_id: '3 months - upsell COP34000',
    duration: '3 months',
    currency: 'COP',
    currencySymbol: 'COP',
  },
  'fm-1900000-cop-3-month-upsell': {
    name: 'fm-1900000-cop-3-month-upsell',
    price: 19000,
    periodPrice: 19000,
    description: 'quarterly upsell',
    disclaimer: 'quarterly',
    product_id: '3 months - upsell COP19000',
    duration: '3 months',
    currency: 'COP',
    currencySymbol: 'COP',
  },
  'fm-1400000-cop-3-month-upsell': {
    name: 'fm-1400000-cop-3-month-upsell',
    price: 14000,
    periodPrice: 14000,
    description: 'quarterly upsell',
    disclaimer: 'quarterly',
    product_id: '3 months - upsell COP14000',
    duration: '3 months',
    currency: 'COP',
    currencySymbol: 'COP',
  },
  'fm-onetime-upsell-guide-2200000-cop': {
    name: 'fm-onetime-upsell-guide-2200000-cop',
    price: 22000,
    periodPrice: 22000,
    description: 'one-time',
    product_id: 'one-time payment - COP22000',
    duration: 'one-time',
    currency: 'COP',
    currencySymbol: 'COP',
  },
  'fm-onetime-upsell-guide-4300000-cop': {
    name: 'fm-onetime-upsell-guide-4300000-cop',
    price: 43000,
    periodPrice: 43000,
    description: 'one-time',
    product_id: 'one-time payment - COP43000',
    duration: 'one-time',
    currency: 'COP',
    currencySymbol: 'COP',
  },
  // cad territory pricing
  'fm-5899-cad-1-month-intro-399-cad-3-day-sub': {
    name: 'fm-5899-cad-1-month-intro-399-cad-3-day-sub',
    price: 58.99,
    periodPrice: 3.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - $58.99',
    duration: '3 days - month',
    currency: 'CAD',
    currencySymbol: 'C$',
  },
  'fm-5899-cad-1-month-intro-899-cad-3-day-sub': {
    name: 'fm-5899-cad-1-month-intro-899-cad-3-day-sub',
    price: 58.99,
    periodPrice: 8.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - $58.99',
    duration: '3 days - month',
    currency: 'CAD',
    currencySymbol: 'C$',
  },
  'fm-5899-cad-1-month-intro-2999-cad-1-month-sub': {
    name: 'fm-5899-cad-1-month-intro-2999-cad-1-month-sub',
    price: 58.99,
    periodPrice: 58.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - $58.99',
    duration: '1 month',
    currency: 'CAD',
    currencySymbol: 'C$',
  },
  'fm-8899-cad-3-month-intro-5899-cad-3-month-sub': {
    name: 'fm-8899-cad-3-month-intro-5899-cad-3-month-sub',
    price: 88.99,
    periodPrice: 88.99,
    description: 'quarterly',
    disclaimer: 'quarterly',
    product_id: '3 months - $88.99',
    duration: '3 months',
    currency: 'CAD',
    currencySymbol: 'C$',
  },
  'fm-1499-cad-1-month-upsell': {
    name: 'fm-1499-cad-1-month-upsell',
    price: 14.99,
    periodPrice: 14.99,
    description: 'monthly upsell',
    disclaimer: 'monthly',
    product_id: '1 month - upsell $14.99',
    duration: '1 month',
    currency: 'CAD',
    currencySymbol: 'C$',
  },
  'fm-2099-cad-1-month-upsell': {
    name: 'fm-2099-cad-1-month-upsell',
    price: 20.99,
    periodPrice: 20.99,
    description: 'monthly upsell',
    disclaimer: 'monthly',
    product_id: '1 month - upsell $20.99',
    duration: '1 month',
    currency: 'CAD',
    currencySymbol: 'C$',
  },
  'fm-1199-cad-1-month-upsell': {
    name: 'fm-1199-cad-1-month-upsell',
    price: 11.99,
    periodPrice: 11.99,
    description: 'monthly upsell',
    disclaimer: 'monthly',
    product_id: '1 month - upsell $11.99',
    duration: '1 month',
    currency: 'CAD',
    currencySymbol: 'C$',
  },
  'fm-899-cad-1-month-upsell': {
    name: 'fm-899-cad-1-month-upsell',
    price: 8.99,
    periodPrice: 8.99,
    description: 'monthly upsell',
    disclaimer: 'monthly',
    product_id: '1 month - upsell $8.99',
    duration: '1 month',
    currency: 'CAD',
    currencySymbol: 'C$',
  },
  'fm-1499-cad-3-month-upsell': {
    name: 'fm-1499-cad-3-month-upsell',
    price: 14.99,
    periodPrice: 14.99,
    description: 'quarterly upsell',
    disclaimer: 'quarterly',
    product_id: '3 months - upsell $14.99',
    duration: '3 months',
    currency: 'CAD',
    currencySymbol: 'C$',
  },
  'fm-2099-cad-3-month-upsell': {
    name: 'fm-2099-cad-3-month-upsell',
    price: 20.99,
    periodPrice: 20.99,
    description: 'quarterly upsell',
    disclaimer: 'quarterly',
    product_id: '3 months - upsell $20.99',
    duration: '3 months',
    currency: 'CAD',
    currencySymbol: 'C$',
  },
  'fm-1199-cad-3-month-upsell': {
    name: 'fm-1199-cad-3-month-upsell',
    price: 11.99,
    periodPrice: 11.99,
    description: 'quarterly upsell',
    disclaimer: 'quarterly',
    product_id: '3 months - upsell $11.99',
    duration: '3 months',
    currency: 'CAD',
    currencySymbol: 'C$',
  },
  'fm-899-cad-3-month-upsell': {
    name: 'fm-899-cad-3-month-upsell',
    price: 8.99,
    periodPrice: 8.99,
    description: 'quarterly upsell',
    disclaimer: 'quarterly',
    product_id: '3 months - upsell $8.99',
    duration: '3 months',
    currency: 'CAD',
    currencySymbol: 'C$',
  },
  'fm-onetime-upsell-guide-1299-cad': {
    name: 'fm-onetime-upsell-guide-1299-cad',
    price: 12.99,
    periodPrice: 12.99,
    description: 'one-time',
    product_id: 'one-time payment - $12.99',
    duration: 'one-time',
    currency: 'CAD',
    currencySymbol: 'C$',
  },
  'fm-onetime-upsell-guide-2599-cad': {
    name: 'fm-onetime-upsell-guide-2599-cad',
    price: 25.99,
    periodPrice: 25.99,
    description: 'one-time',
    product_id: 'one-time payment - $25.99',
    duration: 'one-time',
    currency: 'CAD',
    currencySymbol: 'C$',
  },
  // aud territory pricing
  'fm-5199-aud-1-month-intro-399-aud-3-day-sub': {
    name: 'fm-5199-aud-1-month-intro-399-aud-3-day-sub',
    price: 51.99,
    periodPrice: 3.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - A$51.99',
    duration: '3 days - month',
    currency: 'AUD',
    currencySymbol: 'A$',
  },
  'fm-5199-aud-1-month-intro-799-aud-3-day-sub': {
    name: 'fm-5199-aud-1-month-intro-799-aud-3-day-sub',
    price: 51.99,
    periodPrice: 7.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - A$51.99',
    duration: '3 days - month',
    currency: 'AUD',
    currencySymbol: 'A$',
  },
  'fm-5199-aud-1-month-intro-2599-aud-1-month-sub': {
    name: 'fm-5199-aud-1-month-intro-2599-aud-1-month-sub',
    price: 51.99,
    periodPrice: 51.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - A$51.99',
    duration: '1 month',
    currency: 'AUD',
    currencySymbol: 'A$',
  },
  'fm-7799-aud-3-month-intro-5199-aud-3-month-sub': {
    name: 'fm-7799-aud-3-month-intro-5199-aud-3-month-sub',
    price: 77.99,
    periodPrice: 77.99,
    description: 'quarterly',
    disclaimer: 'quarterly',
    product_id: '3 months - A$77.99',
    duration: '3 months',
    currency: 'AUD',
    currencySymbol: 'A$',
  },
  'fm-1299-aud-1-month-upsell': {
    name: 'fm-1299-aud-1-month-upsell',
    price: 12.99,
    periodPrice: 12.99,
    description: 'monthly upsell',
    disclaimer: 'monthly',
    product_id: '1 month - upsell A$12.99',
    duration: '1 month',
    currency: 'AUD',
    currencySymbol: 'A$',
  },
  'fm-1799-aud-1-month-upsell': {
    name: 'fm-1799-aud-1-month-upsell',
    price: 17.99,
    periodPrice: 17.99,
    description: 'monthly upsell',
    disclaimer: 'monthly',
    product_id: '1 month - upsell A$17.99',
    duration: '1 month',
    currency: 'AUD',
    currencySymbol: 'A$',
  },
  'fm-999-aud-1-month-upsell': {
    name: 'fm-999-aud-1-month-upsell',
    price: 9.99,
    periodPrice: 9.99,
    description: 'monthly upsell',
    disclaimer: 'monthly',
    product_id: '1 month - upsell A$9.99',
    duration: '1 month',
    currency: 'AUD',
    currencySymbol: 'A$',
  },
  'fm-799-aud-1-month-upsell': {
    name: 'fm-799-aud-1-month-upsell',
    price: 7.99,
    periodPrice: 7.99,
    description: 'monthly upsell',
    disclaimer: 'monthly',
    product_id: '1 month - upsell A$7.99',
    duration: '1 month',
    currency: 'AUD',
    currencySymbol: 'A$',
  },
  'fm-1299-aud-3-month-upsell': {
    name: 'fm-1299-aud-3-month-upsell',
    price: 12.99,
    periodPrice: 12.99,
    description: 'quarterly upsell',
    disclaimer: 'quarterly',
    product_id: '3 months - upsell A$12.99',
    duration: '3 months',
    currency: 'AUD',
    currencySymbol: 'A$',
  },
  'fm-1799-aud-3-month-upsell': {
    name: 'fm-1799-aud-3-month-upsell',
    price: 17.99,
    periodPrice: 17.99,
    description: 'quarterly upsell',
    disclaimer: 'quarterly',
    product_id: '3 months - upsell A$17.99',
    duration: '3 months',
    currency: 'AUD',
    currencySymbol: 'A$',
  },
  'fm-999-aud-3-month-upsell': {
    name: 'fm-999-aud-3-month-upsell',
    price: 9.99,
    periodPrice: 9.99,
    description: 'quarterly upsell',
    disclaimer: 'quarterly',
    product_id: '3 months - upsell A$9.99',
    duration: '3 months',
    currency: 'AUD',
    currencySymbol: 'A$',
  },
  'fm-799-aud-3-month-upsell': {
    name: 'fm-799-aud-3-month-upsell',
    price: 7.99,
    periodPrice: 7.99,
    description: 'quarterly upsell',
    disclaimer: 'quarterly',
    product_id: '3 months - upsell A$7.99',
    duration: '3 months',
    currency: 'AUD',
    currencySymbol: 'A$',
  },
  'fm-onetime-upsell-guide-1199-aud': {
    name: 'fm-onetime-upsell-guide-1199-aud',
    price: 11.99,
    periodPrice: 11.99,
    description: 'one-time',
    product_id: 'one-time payment - A$11.99',
    duration: 'one-time',
    currency: 'AUD',
    currencySymbol: 'A$',
  },
  'fm-onetime-upsell-guide-2299-aud': {
    name: 'fm-onetime-upsell-guide-2299-aud',
    price: 22.99,
    periodPrice: 22.99,
    description: 'one-time',
    product_id: 'one-time payment - A$22.99',
    duration: 'one-time',
    currency: 'AUD',
    currencySymbol: 'A$',
  },
  // zar territory pricing
  'fm-32999-zar-1-month-intro-2299-zar-3-day-sub': {
    name: 'fm-32999-zar-1-month-intro-2299-zar-3-day-sub',
    price: 329.99,
    periodPrice: 22.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - R329.99',
    duration: '3 days - month',
    currency: 'ZAR',
    currencySymbol: 'R',
  },
  'fm-32999-zar-1-month-intro-4599-zar-3-day-sub': {
    name: 'fm-32999-zar-1-month-intro-4599-zar-3-day-sub',
    price: 329.99,
    periodPrice: 45.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - R329.99',
    duration: '3 days - month',
    currency: 'ZAR',
    currencySymbol: 'R',
  },
  'fm-32999-zar-1-month-intro-18099-zar-1-month-sub': {
    name: 'fm-32999-zar-1-month-intro-18099-zar-1-month-sub',
    price: 329.99,
    periodPrice: 329.99,
    description: 'monthly',
    disclaimer: 'monthly',
    product_id: '1 month - R329.99',
    duration: '1 month',
    currency: 'ZAR',
    currencySymbol: 'R',
  },
  'fm-49399-zar-3-month-intro-32999-zar-3-month-sub': {
    name: 'fm-49399-zar-3-month-intro-32999-zar-3-month-sub',
    price: 493.99,
    periodPrice: 493.99,
    description: 'quarterly',
    disclaimer: 'quarterly',
    product_id: '3 months - R493.99',
    duration: '3 months',
    currency: 'ZAR',
    currencySymbol: 'R',
  },
  'fm-8299-zar-1-month-upsell': {
    name: 'fm-8299-zar-1-month-upsell',
    price: 82.99,
    periodPrice: 82.99,
    description: 'monthly upsell',
    disclaimer: 'monthly',
    product_id: '1 month - upsell R82.99',
    duration: '1 month',
    currency: 'ZAR',
    currencySymbol: 'R',
  },
  'fm-11999-zar-1-month-upsell': {
    name: 'fm-11999-zar-1-month-upsell',
    price: 119.99,
    periodPrice: 119.99,
    description: 'monthly upsell',
    disclaimer: 'monthly',
    product_id: '1 month - upsell R119.99',
    duration: '1 month',
    currency: 'ZAR',
    currencySymbol: 'R',
  },
  'fm-6599-zar-1-month-upsell': {
    name: 'fm-6599-zar-1-month-upsell',
    price: 65.99,
    periodPrice: 65.99,
    description: 'monthly upsell',
    disclaimer: 'monthly',
    product_id: '1 month - upsell R65.99',
    duration: '1 month',
    currency: 'ZAR',
    currencySymbol: 'R',
  },
  'fm-4999-zar-1-month-upsell': {
    name: 'fm-4999-zar-1-month-upsell',
    price: 49.99,
    periodPrice: 49.99,
    description: 'monthly upsell',
    disclaimer: 'monthly',
    product_id: '1 month - upsell R49.99',
    duration: '1 month',
    currency: 'ZAR',
    currencySymbol: 'R',
  },
  'fm-8299-zar-3-month-upsell': {
    name: 'fm-8299-zar-3-month-upsell',
    price: 82.99,
    periodPrice: 82.99,
    description: 'quarterly upsell',
    disclaimer: 'quarterly',
    product_id: '3 months - upsell R82.99',
    duration: '3 months',
    currency: 'ZAR',
    currencySymbol: 'R',
  },
  'fm-11999-zar-3-month-upsell': {
    name: 'fm-11999-zar-3-month-upsell',
    price: 119.99,
    periodPrice: 119.99,
    description: 'quarterly upsell',
    disclaimer: 'quarterly',
    product_id: '3 months - upsell R119.99',
    duration: '3 months',
    currency: 'ZAR',
    currencySymbol: 'R',
  },
  'fm-6599-zar-3-month-upsell': {
    name: 'fm-6599-zar-3-month-upsell',
    price: 65.99,
    periodPrice: 65.99,
    description: 'quarterly upsell',
    disclaimer: 'quarterly',
    product_id: '3 months - upsell R65.99',
    duration: '3 months',
    currency: 'ZAR',
    currencySymbol: 'R',
  },
  'fm-4999-zar-3-month-upsell': {
    name: 'fm-4999-zar-3-month-upsell',
    price: 49.99,
    periodPrice: 49.99,
    description: 'quarterly upsell',
    disclaimer: 'quarterly',
    product_id: '3 months - upsell R49.99',
    duration: '3 months',
    currency: 'ZAR',
    currencySymbol: 'R',
  },
  'fm-onetime-upsell-guide-7399-zar': {
    name: 'fm-onetime-upsell-guide-7399-zar',
    price: 73.99,
    periodPrice: 73.99,
    description: 'one-time',
    product_id: 'one-time payment - R73.99',
    duration: 'one-time',
    currency: 'ZAR',
    currencySymbol: 'R',
  },
  'fm-onetime-upsell-guide-14999-zar': {
    name: 'fm-onetime-upsell-guide-14999-zar',
    price: 149.99,
    periodPrice: 149.99,
    description: 'one-time',
    product_id: 'one-time payment - R149.99',
    duration: 'one-time',
    currency: 'ZAR',
    currencySymbol: 'R',
  },
};
